module.exports = __webpack_public_path__ + "assets/img/weixin.91139e7d.jpg";